import { Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { ReactComponent as CheckCircle } from "shared/assets/images/check-circle.svg";

const ConviteRadarSucesso: React.FC<RouteComponentProps> = (props) => {
  const { history } = props;
  const { t } = useTranslation("radar");
  return (
    <div
      className="radar"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Row justify="center">
        <Col xs={24}>
          <div className="mensagem-sucesso">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                width: "50%",
                alignItems: "center",
              }}
            >
              <CheckCircle className="check-circle" />
              <Typography.Text style={{ fontSize: 20, margin: "32px 0" }}>
                {t("pages.Radar.mensagemSucessoAguarde")}
              </Typography.Text>
              <button
                className="botao-verde"
                onClick={() => history.push("radar")}
              >
                OK
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ConviteRadarSucesso;
